module.exports = __webpack_public_path__ + "img/element-icons-120-x-76-ic-rank-18@3x.593bd180.png";